
// 郵便番号をフォーマットする関数 (XXX-XXXX形式)
const formatPostalCode = (postalCode: string) => {
  if (!postalCode) return "-";

  // ハイフンや空白を削除
  const cleaned = postalCode.replace(/[-\s]/g, "");

  // 7桁の数字かチェック
  if (cleaned.length === 7 && /^\d+$/.test(cleaned)) {
    // 3桁-4桁の形式に整形
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3)}`;
  }

  // フォーマットできない場合は元の値を返す
  return postalCode;
};

export default formatPostalCode;
